<script setup>
import {ref} from "vue"

const props = defineProps({
  // 分页数组总条数
  total: {
    required: true,
    type: Number,
    default: 0
  },
  // 单页最多显示条目数
  pageSize: {
    type: Number,
    default: 20
  },
  // 分页最长可见数，超出部分显示...
  totalVisible: {
    type: Number,
    default: 7
  }
})
// 当前页数
const page = ref(1)

// 事件
const emit = defineEmits(['pageChange'])

// 翻页
const handleChangePage = () => {
  emit("pageChange")
}
// 获取当前页数
const getPage = () => {
  return page.value
}
// 获取分页条数
const getPageSize = () => {
  return props.pageSize
}
// 重置当前页数为1
const resetPage = () => {
  page.value = 1
}

// 暴露出的函数与变量
defineExpose({
  getPage,
  getPageSize,
  resetPage
})
</script>

<template>
  <div class="flex_right text-right pt-2" style="width: 100%;">
    <v-pagination
        v-model="page"
        :length="Math.ceil(props.total / props.pageSize)"
        :total-visible="props.totalVisible"
        @update:modelValue="handleChangePage"
        v-if="props.total > 0"
    ></v-pagination>
  </div>
</template>

<style scoped>

</style>